// Search over an enum dropdown's options, shared by every RMS enum dropdown
// that grows a search box once the list is long (PortalledEnumDropdown for
// scalar cells since #10808, StatusDropdown for array facts and the entity
// page's editors since #12128), so the two agree on when the box appears and
// what a query matches.

// Option count past which a dropdown grows a search box. Below it, scanning is
// faster than typing and the extra input is just noise and one more tab stop;
// above it (an org's 37-78 document types) scanning is the chore the search
// box exists to remove.
export const ENUM_SEARCH_THRESHOLD = 8;

// The options whose displayed label contains the query, case-insensitively.
// An option renders `enumLabels[option] ?? option`, and that is what the
// query is matched against: a user types what they see. A blank query keeps
// the whole list.
export const filterEnumOptions = (
  options: string[],
  query: string,
  enumLabels?: Record<string, string> | null
): string[] => {
  if (!query.trim()) return options;
  const needle = query.toLowerCase();
  return options.filter((option) =>
    (enumLabels?.[option] ?? option).toLowerCase().includes(needle)
  );
};
